import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './register.css';

function RegisterCompany() {
  const [companyName, setCompanyName] = useState('');
  const [companyPrefix, setCompanyPrefix] = useState('');
  const [adminEmail, setAdminEmail] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [error, setError] = useState('');
  const [companyLogo, setCompanyLogo] = useState(null);

  const navigate = useNavigate();

  const handleLogoChange = (e) => {
    setCompanyLogo(e.target.files[0]);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    formData.append('companyName', companyName);
    formData.append('companyPrefix', companyPrefix); // Even if not used in backend
    formData.append('companyLogo', companyLogo);
    formData.append('adminEmail', adminEmail);
    formData.append('adminPassword', adminPassword);
  
    try {
      const response = await axios.post(
        'https://buildfastvapi.emedha.in/account-setting/api/v1/api/register',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      console.log('Registration Successful:', response.data);
      navigate('/login');
    } catch (err) {
      console.error('Error Response:', err.response?.data || err.message);
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    }
  };
  


  return (
    <div className="register-page-wrapper">
      <div className="register-card">
        
        {/* Logo & Brand */}
        <div className="brand-section">
          <img 
            src="https://png.pngtree.com/template/20190926/ourmid/pngtree-home-repair-logo-with-maintenance-tools-and-house-construction-c-image_309799.jpg" 
            alt="Logo" 
            style={{ width: '40px' }}
            className='brand-logo'
          />
          <span className="brand-name">BuildFast</span>
        </div>

        {/* <Typography style={{ fontSize: '22px', fontWeight: '700', color: '#1f2937' }}>
          Register New Company
        </Typography> */}
        <Typography style={{ fontSize: '14px', color: '#6b7280', marginBottom: '25px' , marginTop: '15px' }}>
          Create a new company account to get started
        </Typography>

        <form onSubmit={handleSubmit}>
          {/* Company Name */}
          <div className="form-group" style={{ textAlign: 'left', marginBottom: '15px' }}>
            <label className="form-label">
              Company Name <span className="required-star">*</span>
            </label>
            <input
              type="text"
              className="custom-input"
              placeholder="Enter company name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
            />
          </div>

          {/* Company Prefix */}
          <div className="form-group" style={{ textAlign: 'left', marginBottom: '15px' }}>
            <label className="form-label">
              Company Prefix <span className="required-star">*</span>
            </label>
            <input
              type="text"
              className="custom-input"
              placeholder="Prefix"
              value={companyPrefix}
              onChange={(e) => setCompanyPrefix(e.target.value)}
              required
            />
          </div>

          {/* Company Logo (File) */}
          <div className="form-group" style={{ textAlign: 'left', marginBottom: '15px' }}>
            <label className="form-label">
              Company Logo <span className="required-star">*</span>
            </label>
            <input
              type="file"
              className="custom-input"
              onChange={handleLogoChange}
              accept="image/*"
              required
            />
          </div>

          {/* Admin Email */}
          <div className="form-group" style={{ textAlign: 'left', marginBottom: '15px' }}>
            <label className="form-label">
              Admin Email <span className="required-star">*</span>
            </label>
            <input
              type="email"
              className="custom-input"
              placeholder="admin@company.com"
              value={adminEmail}
              onChange={(e) => setAdminEmail(e.target.value)}
              required
            />
          </div>

          {/* Admin Password */}
          <div className="form-group" style={{ textAlign: 'left', marginBottom: '20px' }}>
            <label className="form-label">
              Admin Password <span className="required-star">*</span>
            </label>
            <input
              type="password"
              className="custom-input"
              placeholder="••••••••"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              required
            />
          </div>

          <Button type="submit" fullWidth variant="contained" className="register-btn">
            Register Company
          </Button>
        </form>

        <div className="login-redirect-text">
          Already registered? <Link to="/login" className="login-link">Login here</Link>
        </div>

        {error && <Typography style={{ color: '#e31b23', marginTop: '10px', fontSize: '13px' }}>{error}</Typography>}

        <Typography className="footer-copyright">
          ©2026 Emedha Technologies All Rights Reserved.
        </Typography>
      </div>
    </div>



  );
}

export default RegisterCompany;

